import { useWorkspace } from '../../lib/workspace'
import { useMe } from '../auth/session'
import { NewCaseDialog } from './new-case-dialog'

/** The one New case dialog, opened from the top bar, Ctrl+K and `g n`. Billing writes nothing to Desk, so it never mounts. */
export function NewCaseHost() {
  const ws = useWorkspace()
  const me = useMe()
  if (!me?.can_write_desk) return null
  return <NewCaseDialog open={ws.newCaseOpen} onOpenChange={ws.setNewCaseOpen} />
}

/** Top-bar entry: icon only on a phone, with its label from `md` up. */
export function NewCaseButton() {
  const ws = useWorkspace()
  const me = useMe()
  if (!me?.can_write_desk) return null
  return (
    <button
      type="button"
      onClick={() => ws.setNewCaseOpen(true)}
      title="New case (g n)"
      aria-label="New case"
      className="inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-md border border-border px-2 text-sm font-medium hover:bg-muted"
    >
      <span aria-hidden="true">+</span>
      <span className="hidden md:inline">New case</span>
    </button>
  )
}
